const crafts = [
  {
    number: '01',
    title: '手でこねる',
    subtitle: '毎回、ゼロから。',
    desc: '生地は毎回、手でこねる。伸ばして、のせて。特別な機械は使わない。手の感触で、生地の状態を確かめながら。',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/87ff23c1c54f8aa4589ef2e11b1e46dc.webp',
    alt: '手ごね生地 - 手でこねるピザ生地',
  },
  {
    number: '02',
    title: '400℃の窯',
    subtitle: '一気に、パリッと。',
    desc: '400°Cの窯で一気に焼く。5分から10分。これだけで、パリッと薄い一枚が焼きあがる。',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/10f45d77b8b4e93381dfc2d51fbfeff0.webp',
    alt: '400℃のレンガ窯 - ピザを焼く',
  },
  {
    number: '03',
    title: '焼きたて一枚',
    subtitle: 'ここでしか、この瞬間。',
    desc: '焼きたてを手に持った瞬間の熱さと香ばしさは、ここでしか味わえない。直径35cm。一人でも食べきれる軽さ。',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/22c59cb7ac505b1654714f17c9dcf1eb.webp',
    alt: '窯から取り出すパリパリのピザ',
  },
];

export default function Craftsmanship() {
  return (
    <section id="craft" className="bg-cream py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-tankan/10 text-tankan text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / CRAFT
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-rounded font-black text-kiln leading-tight">
            手でこねて、400℃で焼く、それだけ。<br className="hidden md:block" />もちもちパリパリの秘訣。
          </h2>
          <p className="mt-4 text-kiln/80 font-rounded text-base max-w-md mx-auto">
            特別な技法があるわけじゃない。でも、焼きたての一枚はここでしか。
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {crafts.map((c) => (
            <div
              key={c.number}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6">
                <span className="inline-block w-8 h-8 flex items-center justify-center bg-kiln-dark text-white text-xs font-rounded font-black rounded-full mb-3">
                  {c.number}
                </span>
                <h3 className="text-xl font-rounded font-black text-kiln mb-1">{c.title}</h3>
                <p className="text-tankan text-sm font-rounded font-bold mb-3">{c.subtitle}</p>
                <p className="text-kiln/85 font-rounded text-sm leading-relaxed">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Full-width quote */}
        <div className="mt-16 bg-kiln rounded-2xl p-10 text-center">
          <p className="text-white/90 text-xl md:text-2xl font-rounded font-black leading-relaxed">
            「焼きたてを手に持った瞬間の熱さと香ばしさは、<br className="hidden md:block" />
            ここでしか味わえない。」
          </p>
        </div>
      </div>
    </section>
  );
}
